import { Avatar, Card, CardHeader } from '@auth0/quantum-product';
import * as React from 'react';
export var Entry = function (_a) {
    var title = _a.title, url = _a.url, logo = _a.logo;
    return (React.createElement(Card, { size: "small", button: true, component: "a", href: url },
        React.createElement(CardHeader, { avatar: React.createElement(Avatar, { sx: { backgroundColor: 'transparent' }, imgFit: "contain", type: "logo", src: logo, alt: "Quickstart logo" }), titleTypographyProps: { sx: { fontSize: 'body1.fontSize' } }, title: title })));
};
